module.exports = __webpack_public_path__ + "img/1spade-12.fff9f0b3.svg";